<template>
    <div id="mine">
        <div class="header" flex-align>
            <div class="avater">
                <img v-if="isLogin&&userInfo.avatarurl" :src="userInfo.avatarurl" alt="">
                <img v-else src="./img/unAvatar.png" alt="">
            </div>
            <div class="user_name">
                <div @click="handleLogin" class="name_text">{{ isLogin ? userInfo.nickname : '立即登录' }}</div>
                <div v-if="isLogin" class="user_id"> ID：{{ userInfo.uid }}</div>
            </div>
        </div>
        <div class="content">
            <div class="vip">
                <img class="copper" src="./img/copper.png">
                <div class="vip_top" flex-align>
                    <div class="top_left">
                        <div class="score_label">当前积分</div>
                        <div class="score_count">{{ isLogin ? userInfo.score_balance : 0 }}</div>
                    </div>
                    <div class="buy_btn" flex-center @click="handleItemClick(0)">购买会员</div>
                </div>
                <div class="split_line"></div>
                <div class="vip_bottom">
                    <div>开通会员赠送积分享受更多权益</div>
                    <img class="right_img" src="./img/right_circle.png" alt="">
                </div>
            </div>
            <div class="link_list">
                <div class="link_item" @click="handleItemClick(1)">
                    <div class="item_main">
                        <img class="item_icon" src="./img/resource.png" alt="">
                        <div class="item_text">个人资料</div>
                    </div>
                    <img class="more_icon" src="./img/icon_img11.png" alt="">
                </div>
                <div class="link_item" @click="handleItemClick(2)">
                    <div class="item_main">
                        <img class="item_icon" src="./img/scan.png" alt="">
                        <div class="item_text">激活码兑换</div>
                    </div>
                    <img class="more_icon" src="./img/icon_img11.png" alt="">
                </div>
                <div class="link_item" @click="handleItemClick(3)">
                    <div class="item_main">
                        <img class="item_icon" src="./img/course.png" alt="">
                        <div class="item_text">MJ 教程</div>
                    </div>
                    <img class="more_icon" src="./img/icon_img11.png" alt="">
                </div>
                <div class="link_item">
                    <div class="item_main" @click="handleItemClick(4)">
                        <img class="item_icon" src="./img/feedback.png" alt="">
                        <div class="item_text">意见反馈</div>
                    </div>
                    <img class="more_icon" src="./img/icon_img11.png" alt="">
                </div>
                <div class="link_item" @click="handleItemClick(5)">
                    <div class="item_main">
                        <img class="item_icon" src="./img/service.png" alt="">
                        <div class="item_text">联系客服</div>
                    </div>
                    <img class="more_icon" src="./img/icon_img11.png" alt="">
                </div>
                <!-- <div class="link_item" @click="handleItemClick(6)">
                    <div class="item_main">
                        <img class="item_icon" src="./img/log.png" alt="">
                        <div class="item_text">更新日志</div>
                    </div>
                    <img class="more_icon" src="./img/icon_img11.png" alt="">
                </div> -->
            </div>
        </div>
        <div class="footer_btn" @click="handleLogout" flex-center v-if="isLogin">
            退出登录
        </div>
        <div class="kefuPopBox" v-if="kefupopSHow">
            <div class="kefuToDetail">
                <img class="kefuImageIcon" src="./img/kefuImg.png"> </img>
                <div class="kefuTit">客服在线</div>

                <div class="kfTimerDetailBOx">
                    <div class="timerItem">人工客服在线时间：</div>
                    <div class="timerItem">上午8:30-11:30，下午14:00-18:00</div>

                    <div :class="isOnline=='在线'?'timerItem isOn animated-yes':'timerItem isOn animated-no'">当前人工客服{{isOnline=='在线'?'在线':'不在线'}}，有问题请：</div>

                    <div class="isOnlBtn" @click="toKf" v-show='SITE_BTN_CONFIG.kefu_url.btn_state'>{{ isOnline == '在线' ? '客服在线' : '留言' }}</div>
		            <div class="closeKefuPOp" v-if='!SITE_BTN_CONFIG.kefu_url.btn_state'>{{ SITE_BTN_CONFIG.kefu_url.tip_msg }}</div>

                </div>
                <div class="closeKefuPOp" @click="kefupopSHow = false">关闭</div>
            </div>
	    </div>
    </div>
</template>
<script type="text/ecmascript-6">
import utils from '../utils';
export default {
    data() {
        return {
            isWxEnv:false,
            isOnline:'在线',
            kefupopSHow:false,
            SITE_BTN_CONFIG:SITE_BTN_CONFIG,
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        },
        isLogin() {
            return this.$store.state.isLogin;
        }
    },
    created() {
        var ua = navigator.userAgent.toLowerCase();
        if ((ua.match(/MicroMessenger/i) == "micromessenger")) {
            this.isWxEnv = true
        }else{
            this.isWxEnv = false
        }
    },
    methods: {
        checkOnlineStatus (){
            const now = new Date();
            const hours = now.getHours();
            const minutes = now.getMinutes();
            const totalMinutes = hours * 60 + minutes;

            // 时间范围配置（分钟数计算）
            const morningStart = 8 * 60 + 30;   // 08:30 → 510
            const morningEnd = 11 * 60 + 30;    // 11:30 → 690
            const afternoonStart = 14 * 60;     // 14:00 → 840
            const afternoonEnd = 18 * 60;       // 18:00 → 1080

            // 判断当前是否在时间范围内
            const isOnlines = (totalMinutes >= morningStart && totalMinutes <= morningEnd) ||
                            (totalMinutes >= afternoonStart && totalMinutes <= afternoonEnd);

            this.isOnline = isOnlines ? '在线' : '不在线';
        },
        toKfPop(){
            this.checkOnlineStatus()
            this.kefupopSHow = true
        },
        toKf(){
          utils.tokf()
        },
        handleItemClick(type){
            if(type == 5){
                // this.$router.push('/contact2')
                this.toKfPop()
                return
            }
            if(this.checkLogin()){
                if(type == 0){
                    this.$router.push('/member')
                }else if(type == 1){
                    this.$router.push('/info')
                }else if(type == 2){
                    this.$store.commit('setShowCodeExchange', true)
                }else if(type == 3){
                    location.href = "https://docs.qq.com/doc/DUm9GTXdYa1NnbkxN"
                }
            }

        },
        handleLogout () {
            // 退出
            this.$confirm('确定要退出当前账号?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                customClass:'confirm_box'
            }).then(() => {
                this.$store.commit('setUserInfo', null)
                this.$store.commit('setIsLogin', false)
              localStorage.clear();
              window.location.reload();
            }).catch(() => {
            });
        },
        handleLogin () {
            // 登录
            if (!this.isLogin) {
                if(this.isWxEnv){
                    // 微信环境内
                    window.location.href = `${API_SERVER}/api/wx/jumpwap/?appid=${APP_ID}`
                }else{
                    this.$store.commit('setShowLogin', true)
                }
            }
        },
        checkLogin(){
            if (!this.isLogin) {
                this.$store.commit('setShowLogin', true)
                return false;
            }else{
                return true;
            }
        }
    },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
#mine {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  padding-bottom: 45px;
    .header {
        padding: 41px 29px 23px;

        .avater {
            border-radius: 100px;
            margin-right: 10px;
            overflow: hidden;
            border: 2px solid #fff;

            img {
                border: none;
                width: 60px;
                height: 60px;
                object-fit: contain;
                display: block;
            }
        }

        .user_name {
            flex: 1 1 0%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            .name_text {
                font-weight: 700;
                font-size: 17px;
            }

            .user_id {
                font-size: 12px;
                margin-top: 10px;
                color: rgb(166, 166, 166);
            }
        }
    }

    .content{
        flex: 1 1 0%;
        overflow-y: auto;
        padding: 0 20px;
        &::-webkit-scrollbar {
            margin-left: 5px !important;
            display: block !important;
            width: 6px !important;
        }
        &::-webkit-scrollbar-thumb {
            height: 30px !important;
            background-color: #777 !important;
            border-radius: 10px !important;
        }
        .vip{
            position: relative;
            width: 100%;
            background: linear-gradient(90deg, #171a29 0%, #2d2f47 100%);
            border-radius: 11px;
            padding: 14px 20px 12px;
            color: rgba(255, 255, 255, 0.62);
            .copper{
                position: absolute;
                right: 40px;
                bottom: 10px;
                z-index: 0;
                width: 100px;
                height: 100px;
            }
            .vip_top{
                display: flex;
                align-items: center;
                .top_left{
                    flex: 1 1 0%;
                    z-index: 1;
                    .score_label{
                        margin-bottom: 10px;
                    }
                    .score_count{
                        font-size: 24px;
                        color: #fff;
                    }
                }
                .buy_btn{
                    font-weight: 700;
                    width: 81px;
                    height: 33px;
                    color: #3c341d;
                    background-image: linear-gradient(to bottom,#fdf2d8,#f8d49b);
                    border-radius: 9999px;
                    cursor: pointer;
                    z-index: 1;

                }
            }
            .split_line{
                height: 1px;
                margin: 15px 0 10px;
                background-color: rgba(216, 216, 216, 0.15);
                width: 100%;
            }
            .vip_bottom{
                display: flex;
                align-items: center;
                justify-content: space-between;
                .right_img{
                    width: 18px;
                    height: 18px;
                }
            }
        }

        .link_list{
            padding: 2px 20px 38px;
            border-radius: 15px;
            margin: 20px 0;
            background-color: #24262e;
            .link_item{
                border-bottom: 1px solid rgba(216, 216, 216, 0.15);
                padding: 18px 0;
                display: flex;
                align-items: center;
                cursor: pointer;
                .item_main{
                    flex: 1 1 0%;
                    display: flex;
                    align-items: center;
                    .item_icon{
                        width: 22px;
                        height: 22px;
                        margin-right: 12px;
                        display: block;
                        border: none;
                    }
                    .item_text{
                        font-size: 15px;
                    }
                }
                .more_icon{
                    height: 14px;
                }
            }
        }
    }
    
    .footer_btn{
        height: 50px;
        background-color: #24262e;
        border-radius: 10px;
        cursor: pointer;
        margin: 10px 20px 20px;
    }
}
.kefuPopBox{
	position: fixed;
	z-index: 999;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	background: rgba(0,0,0,.8);
	display: flex;
	align-items: center;
	justify-content: center;
	.kefuToDetail{
		width: calc(100% - 90px);
		display: flex;
		flex-direction: column;
		// align-items: center;
		background: #fff;
		border-radius: 10px;
		.kefuImageIcon{
			width: 100px;
			height: 100px;
			align-self: center;
			margin-top:50px;
		}
		.kefuTit{
			margin-top: 15px;
			font-size: 16px;
			font-weight: 600;
			align-self: center;
		}
		.kfTimerDetailBOx{
			color: #000;
			font-size: 14px;
			width: 80%;
			margin: 0 auto;
			margin-top: 20px;
			.timerItem{
				line-height: 20px;
			}
			.isOn{
				margin-top: 20px;
			}
			.isOnlBtn{
				width: 100%;
				padding: 10px 0;
				color: #fff;
				background: #000;
				border-radius: 8px;
				text-align: center;
				margin: 15px 0;
				// margin-bottom: 70px;
				cursor: pointer;
			}
		}
		.closeKefuPOp{
			margin-top: 5px;
			margin-bottom: 25px;
			align-self: center;
			color: #999;
			font-size: 14px;
		}
	}
}

.animated-yes{
	animation: colorChange 1s infinite;
}

.animated-no{
	animation: colorChangeNo 1s infinite;
}
@keyframes colorChange {
    0% {
        color: #07c160;
    }
    100% {
        color: #fff;
    }
}

@keyframes colorChangeNo {
    0% {
        color: #ec3b3b;
    }
    100% {
        color: #fff;
    }
}

</style>